export const newStandardInitialValues = (values) => ({
  caption: values?.caption || "",
  isDefault: values?.isDefault || false,
  findingTypes: values?.findingTypes || [],
});
